<template>
  <v-app id="inspire" v-bind:style="{ background: $vuetify.theme.themes.light.background}">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted(){
  }
};
</script>
